var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-filter report-errors"},[_c('i-switch',{model:{value:(_vm.onlyError),callback:function ($$v) {_vm.onlyError=$$v},expression:"onlyError"}}),_c('div',{staticClass:"ms-help"},[_vm._v("Только с ошибками")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }